'use strict';

var cleanCID = require('../utils/clean-cid');

var v = require('is-ipfs');

var toPull = require('stream-to-pull-stream');

var deferred = require('pull-defer');

module.exports = function (send) {
  return function (hash, opts) {
    opts = opts || {};
    var p = deferred.source();

    try {
      hash = cleanCID(hash);
    } catch (err) {
      if (!v.ipfsPath(hash)) {
        return p.end(err);
      }
    }

    var query = {
      offset: opts.offset,
      length: opts.length
    };
    send({
      path: 'cat',
      args: hash,
      buffer: opts.buffer,
      qs: query
    }, function (err, stream) {
      if (err) {
        return p.end(err);
      }

      p.resolve(toPull(stream));
    });
    return p;
  };
};